import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path d="M30.69,24.8c-0.28,0.61-0.61,1.2-0.99,1.76c0.59,0.48,0.88,0.83,0.92,0.881l1.57-1.23C32.14,26.15,31.66,25.55,30.69,24.8z" />
    <path
      d="M20,20.861c-2.916,0-5.287-2.371-5.287-5.287s2.372-5.288,5.287-5.288s5.288,2.372,5.288,5.288S22.915,20.861,20,20.861z
	 M20,12.287c-1.813,0-3.287,1.475-3.287,3.288s1.475,3.288,3.287,3.288c1.813,0,3.288-1.475,3.288-3.288S21.813,12.287,20,12.287z"
    />
    <path d="M29.7,26.56c0.38-0.56,0.71-1.149,0.99-1.76c0.97,0.75,1.449,1.351,1.5,1.41" />
    <path fill="none" stroke="#000000" strokeWidth="2" strokeMiterlimit="10" d="M29.7,12.922" />
    <path d="M29.539,16.583l-1.855-0.746c0.822-2.046-0.173-4.38-2.219-5.203l0.746-1.855C29.28,10.013,30.773,13.514,29.539,16.583z" />
    <path
      d="M32.19,26.21c-1.381,2.23-4.33,7.38-12.19,7.51c-6.61,0.11-10.59-4.42-12.19-7.51c0.05-0.06,0.53-0.66,1.5-1.41
	c1.78-1.37,5.22-3.24,10.69-3.24c5.47,0,8.91,1.87,10.69,3.24c-0.221,0.49-0.48,0.96-0.771,1.41c-0.07,0.12-0.14,0.24-0.22,0.35
	c-0.13-0.109-0.28-0.229-0.45-0.35c-1.56-1.14-4.52-2.65-9.25-2.65c-4.73,0-7.69,1.511-9.25,2.65c-0.17,0.12-0.32,0.24-0.45,0.35
	c2.1,3.11,5.67,5.16,9.7,5.16c4.03,0,7.6-2.05,9.7-5.16"
    />
    <path
      d="M34.084,18.356l-1.855-0.746c0.891-2.215,0.865-4.645-0.072-6.841c-0.937-2.196-2.672-3.896-4.887-4.786l0.746-1.855
	c2.71,1.09,4.834,3.17,5.98,5.857C35.143,12.673,35.174,15.646,34.084,18.356z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/UserVoice.jsx